// extracted by css-extract-rspack-plugin
export default {"root":"DzPPw","label":"ZRwJA","description":"mI9tN","icon":"rxMjC","input":"V0FLb","inner":"TEuML","body":"fokzT"};